<a [routerLink]="[this.cellValue.url_edit, cellValue.data.id]" *ngIf="canDo(cellValue?.module,'Editar')"
    id="_top{{ cellValue?.data?.id }}" data-bs-toggle="tooltip" data-placement="top"
    title="Editar {{cellValue?.singular_module}}" style="cursor: pointer; margin-left: 8px;">
    <img src="../../../../assets/img/icons/edit-02.svg" alt="" [width]="'20'">
</a>
<a [routerLink]="['/unit/list-checklist', cellValue.data.id]" *ngIf="canDo(cellValue?.module, 'Ver detalle de la unidad')"
    id="_top{{ cellValue?.data?.id }}" data-bs-toggle="tooltip" data-bs-placement="top" title="Ver detalles de la unidad"
    style="cursor: pointer; margin-left: 8px;">
    <img src="../../../../assets/img/icons/view.svg" alt="" [width]="'20'">
</a>

<a [routerLink]="['/unit/list-checklist', cellValue.data.id]"
    *ngIf="canDo(cellValue?.module, 'Ver checklist') && cellValue.data.has_checklist"
    id="_top{{ cellValue?.data?.id }}" data-bs-toggle="tooltip" data-bs-placement="top" title="Ver checklist"
    style="cursor: pointer; margin-left: 8px;">
    <img src="../../../../assets/img/icons/check-list.svg" alt="ver checklist" [width]="'20'">
</a>

<a href="javascript:void(0);" (click)="checklistEvent(cellValue.data)"
    *ngIf="canDo(cellValue?.module, 'Checklist') && !cellValue.data.has_checklist"
    id="_top{{ cellValue?.data?.id }}" data-bs-toggle="tooltip" data-bs-placement="top" title="Crear checklist"
    style="cursor: pointer; margin-left: 8px;">
    <img src="../../../../assets/img/icons/file-add.svg" alt="" [width]="'20'">
</a>
<a href="javascript:void(0);" (click)="fuelConsumptionEvent(cellValue.data)"
    *ngIf="canDo(cellValue?.module, 'Validacion de consumo') && cellValue?.data?.pending_fuel_validations > 0" id="_top{{ cellValue?.data?.id }}" data-bs-toggle="tooltip"
    data-bs-placement="top" title="Validación de registro pendiente" style="cursor: pointer; margin-left: 8px;">
    <img src="../../../../assets/img/icons/validation-approval.svg" alt="" [width]="'20'">
</a>
<a href="javascript:void(0);" (click)="fuelConsumptionEvent(cellValue.data)"
    *ngIf="canDo(cellValue?.module, 'Validacion de consumo') && (cellValue?.data?.completed_fuel_validations_today > 0 || cellValue?.data?.completed_fuel_validations_week > 0)"
    id="_top{{ cellValue?.data?.id }}" data-bs-toggle="tooltip"
    data-bs-placement="top" title="Validación de registro completada" style="cursor: pointer; margin-left: 8px;">
    <img src="../../../../assets/img/icons/checkmark-square-03.svg" alt="" [width]="'20'">
</a>
<a href="javascript:void(0);" (click)="deleteEvent()" *ngIf="canDo(cellValue?.module,'Eliminar')"
    id="_top{{ cellValue?.data?.id }}" data-bs-toggle="tooltip" data-bs-placement="top"
    title="Eliminar {{cellValue?.singular_module}}" style="cursor: pointer; margin-left: 8px;">
    <img src="../../../../assets/img/icons/delete-02.svg" alt="" [width]="'20'">
</a>
<a href="javascript:void(0);" (click)="reportEvent(cellValue.data)" *ngIf="canDo(cellValue?.module,'Reportar falla')"
    id="_top{{ cellValue?.data?.id }}" data-bs-toggle="tooltip" data-placement="top" title="Reportar falla"
    style="cursor: pointer; margin-left: 8px;">
    <img src="../../../../assets/img/icons/maintenance/document-attachment.svg" alt="" [width]="'20'">
</a>